<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        :width="listTypeInfo.width"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template #productNameList="{scope}">
          <template v-if="scope.row.productNameList <= 1">
            <span>
              {{ scope.row.productNameList[0] }}
            </span>
          </template>

          <template v-else>
            <div
              class="productName-item"
              v-for="(item, index) in scope.row.productNameList"
            >
              {{ item }}
            </div>
          </template>
        </template>

        <template #codeStatus="{scope}">
          <span>{{ getCodeStatus(scope.row.codeStatus) }}</span>
        </template>

        <template #supplierType="{scope}">
          <span>{{ getSupplierType(scope.row.supplierType) }}</span>
        </template>
        <!-- 102：审核中，103：审核拒绝，104：已发布的评价办法才能查看 -->
        <!-- 状态: 100:保存，101：待完善，102：审核中，103：审核拒绝 编辑，104：已发布 -->
        <template #handle="{ scope }">
          <span
            class="table-handle-btn"
            @click="
              goPath(scope.row, '/ES/ESorganization/ESorganizationDetail')
            "
            v-if="
              scope.row.codeStatus !== '101' && scope.row.codeStatus !== '103'
            "
          >
            查看
          </span>
          <span
            class="table-handle-btn"
            v-if="scope.row.codeStatus === '104'"
            @click="openConsultDia(scope.row)"
          >
            修改咨询人
          </span>
          <span
            @click="
              goPath(scope.row, '/ES/ESorganization/ESorganizationEdit', true)
            "
            class="table-handle-btn"
            v-if="
              scope.row.codeStatus === '101' || scope.row.codeStatus === '103'
            "
          >
            编辑
          </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>

    <eDialog
      dialogTitle="修改业务咨询人"
      :centerDialogVisible="businessConsultVisible"
      @resetPopupData="setResetPopupData"
      @submitPopupData="setSubmitPopupData"
      :popupWidth="'680px'"
    >
      <div style="margin-bottom: 10px">
        <eui-btn @click="addBusinessConsultName">新增业务咨询人</eui-btn>
      </div>
      <!-- businessConsultEmail: '递四方速递',
          businessConsultName: '胜多负少的',
          businessConsultTel: '胜多负少的', -->
      <eTableList
        :loading="false"
        :table-data="businessConsultTableData"
        :table-label="businessConsultTableLabel"
        :indexShow="true"
      >
        <template #businessConsultEmail="{scope}">
          <el-input
            v-if="scope.row.isEdit"
            v-model="scope.row.businessConsultEmail"
          ></el-input>
          <span v-else>{{ scope.row.businessConsultEmail }}</span>
        </template>
        <template #businessConsultName="{scope}">
          <el-input
            v-if="scope.row.isEdit"
            v-model="scope.row.businessConsultName"
          ></el-input>
          <span v-else>{{ scope.row.businessConsultName }}</span>
        </template>
        <template #businessConsultTel="{scope}">
          <el-input
            v-if="scope.row.isEdit"
            v-model="scope.row.businessConsultTel"
          ></el-input>
          <span v-else>{{ scope.row.businessConsultTel }}</span>
        </template>

        <template #handle="{scope}">
          <eui-btn type="link" @click="editHandle(scope.row, scope.$index)"
            >编辑</eui-btn
          >
          <eui-btn type="link" @click="delHandle(scope.row, scope.$index)"
            >删除</eui-btn
          >
        </template>
      </eTableList>
    </eDialog>
  </div>
</template>
<script>
import Api from '@/modules/projectA/api/ESorganization';
import mixins from './components/mixins';
import {
  tableLabel,
  fieldList,
  listTypeInfo
} from './components/componentsData.js';
import eDialog from '@/components/common/e-dialog.vue';
export default {
  mixins: [mixins],
  components: { eDialog },
  data() {
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        evaluationCode: '',
        evaluateMethodName: '',
        codeStatus: '',
        createTimeStart: '',
        createTimeEnd: '',
        publishTimeStart: '',
        publishTimeEnd: '',
        specialtyName: '',
        productName: '',
        supplierType: ''
      },
      total: 0,
      cloneListQuery: {},
      tableData: [
        /* {
          evaluationId: 35669,
          evaluationCode: 'EQE010116003',
          evaluateMethodName: '钢材物流商评价办法0706',
          createTime: '2023-07-06 15:45:40.0',
          publishTime: '2023-07-06 15:59:38.0',
          codeStatus: '104',
          specialtyName: '材料',
          supplierType: '103',
          delStatus: 0,
          productNameList: [],
        },
        {
          evaluationId: 35669,
          evaluationCode: 'EQE010116003',
          evaluateMethodName: '钢材物流商评价办法0706钢',
          createTime: '2023-07-06 15:45:40.0',
          publishTime: '2023-07-06 15:59:38.0',
          codeStatus: '104',
          specialtyName: '材料',
          supplierType: '103',
          delStatus: 0,
          productNameList: [],
        }, */
      ],
      businessConsultVisible: false,
      businessConsultTableData: [
        /* {
          businessConsultEmail: '136sss@qs.com',
          businessConsultName: '测试1',
          businessConsultTel: '18711111111',
        }, */
      ],
      businessConsultTableLabel: [
        { label: '业务咨询人', slot: 'businessConsultName', align: 'center' },
        { label: '电话', slot: 'businessConsultTel', align: 'center' },
        { label: '邮箱', slot: 'businessConsultEmail', align: 'center' },
        { label: '操作', slot: 'handle', align: 'center' }
      ],
      evaluationId: ''
    };
  },
  created() {
    this.cloneListQuery = this.$options.data().listQuery;
    this.getList(this.listQuery);
  },

  methods: {
    //
    getSupplierType(supplierType) {
      const { supplierTypeList } = this.listTypeInfo;
      const { name } =
        supplierTypeList.find(item => {
          return item.id === Number(supplierType);
        }) || {};
      return name;
    },
    getCodeStatus(codeStatus) {
      const { codeStatusList } = this.listTypeInfo;
      const { name } =
        codeStatusList.find(item => {
          return item.id === Number(codeStatus);
        }) || {};
      return name;
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.evaluationList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = res.data;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },

    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.createTime?.length) {
        val.createTimeStart = val.createTime[0];
        val.createTimeEnd = val.createTime[1];
      } else {
        val.createTimeStart = '';
        val.createTimeEnd = '';
        val.createTime = [];
      }
      if (val.publishTime?.length) {
        val.publishTimeStart = val.publishTime[0];
        val.publishTimeEnd = val.publishTime[1];
      } else {
        val.publishTimeStart = '';
        val.publishTimeEnd = '';
        val.publishTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },

    async goPath(row, path, flag) {
      const { evaluationId = '', supplierType, isStructured } = row;
      if (flag) {
        try {
          const result = await Api.getStep({ evaluationId });
          console.log(result);
          if (result.code === '200') {
            const { step = '' } = result.data;
            this.$router.push({
              path,
              query: {
                step,
                supplierType,
                evaluationId
              }
            });
          }
        } catch (err) {
          console.error(err);
        }
      } else {
        this.$router.push({
          path,
          query: {
            supplierType,
            evaluationId,
            isStructured
          }
        });
      }
    },

    async getConsultList(evaluationId) {
      const result = await Api.consultList({ evaluationId });
      console.log(result);
      if (result.code === '200') {
        this.businessConsultVisible = true;
        if (result?.data?.length > 0) {
          result.data.forEach(item => {
            item.isEdit = false;
          });
          this.businessConsultTableData = [...result.data];
        }
      }
    },
    openConsultDia(row) {
      const { evaluationId = '' } = row;
      this.evaluationId = evaluationId;
      this.getConsultList(evaluationId);
    },

    addBusinessConsultName() {
      const item = {
        businessConsultEmail: '',
        businessConsultName: '',
        businessConsultTel: '',
        isEdit: true
      };
      this.businessConsultTableData.push(item);
    },

    editHandle(row, index) {
      this.$set(this.businessConsultTableData[index], 'isEdit', true);
    },

    delHandle(row, index) {
      this.businessConsultTableData.splice(index, 1);
    },
    // 取消
    setResetPopupData() {
      this.businessConsultVisible = false;
    },
    // 确定
    async setSubmitPopupData() {
      const item = {
        evaluationId: this.evaluationId,
        evaluationBusinessConsultAOList: this.businessConsultTableData
      };
      try {
        const result = await Api.updateConsult(item);
        if (result.code === '200') {
          this.$message.success('修改咨询人成功');
        }
      } finally {
        this.businessConsultVisible = false;
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.productName-item {
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  padding: 8px 0;
  margin: 0 -10px;
  &:last-child {
    border-bottom: none;
    margin-bottom: -8px;
  }
  &:first-child {
    margin-top: -8px;
  }
}
</style>
